export var version = "3.12.5";
//# sourceMappingURL=version.js.map